<template>
  <VueModal modal-class="modal modal-lg-sm event-guide"  :title="`Event Creation Guide ${currentPage} of ${totalPages}`" v-model="modalOpen">
    <div v-if="eventGuide && page">
      <div class="mb-12">
        <h1>
          {{ page.title }}
        </h1>

        <div class="intro-copy" v-html="page.intro" />

        <div class="prose" v-html="page.content" />
      </div>
      <div class="flex justify-center">
        <button type="button" class="button" @click="nextPage">
          {{ buttonText }}
        </button>
      </div>
    </div>
    <div v-else>
      <div class="mb-12">
        <h2 class="text-n-gray-dark text-2xl font-hairline">
          The event guide is currently under construction, please come back soon!
        </h2>
      </div>
    </div>
  </VueModal>
</template>

<script>
import VueModal from '@kouts/vue-modal'
import { eventAPI } from "../../../../../api/eventAPI";
import { craftelementAPI } from "../../../../../api/craftelementAPI";

export default {
  name: "EventGuideModal",
  props: {
    value: { type: Boolean, required: true }
  },
  components: { VueModal },
  computed: {
    modalOpen: {
      get() {
        return this.value;
      },
      set(localModalIsSet) {
        this.$emit('input', localModalIsSet);
      }
    },
    page() {
      if (!this.eventGuide) {
        return null;
      }

      try {
        return this.eventGuide.data[this.currentPage - 1];
      } catch (e) {
        return null;
      }
    },
    totalPages() {
      try {
        return this.eventGuide.meta.pagination.total;
      } catch(_) {
        return 1;
      }
    },
    isLastPage() {
      try {
        return this.currentPage >= this.totalPages;
      } catch(_) {
        return false;
      }
    },
    buttonText() {
      if (this.isLastPage) {
        return this.page.button ? this.page.button : 'Finish';
      }

      return this.page && this.page.button ? this.page.button : 'Next';
    }
  },
  data() {
    return {
      /** @type {EventGuide|boolean} */
      eventGuide: false,
      loading: false,
      currentPage: 1,
      guideLoaded: false,
    }
  },
  methods: {
    async confirmRead() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      await eventAPI.confirmReadGuide();
      await this.$store.dispatch('getMe');

      this.loading = false;
      this.modalOpen = false;
    },
    async loadGuide() {
      this.eventGuide = await craftelementAPI.eventGuide();
      this.guideLoaded = false;
    },
    nextPage() {
      document.getElementsByClassName('vm-wrapper')[0].scrollTop = 0;

      if (this.isLastPage) {
        return this.confirmRead();
      }

      this.currentPage++;
    }
  },
  mounted() {
    this.loadGuide();
  }
}
</script>
